import { render, staticRenderFns } from "./MailGroups.create.vue?vue&type=template&id=09705194&"
import script from "./MailGroups.create.vue?vue&type=script&lang=js&"
export * from "./MailGroups.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports